<template>
    <div class="contacts">
        <post-back :title="tr.contacts" />
        <div class="container">
            <div class="row padding-60">
                <div class="col-sm-6">
                    <h2>{{tr.iwep_full}}</h2>
                    <h3>{{tr.adr}}:</h3> {{tr.address}}
                    <h3>{{tr.phone}}:</h3> <a href="tel:+7 (7172) 70-83-26">{{tr.iwep_phone}}</a>
                    <h3>{{tr.email}}:</h3> <a href="mailto:office@iwep.kz">{{tr.iwep_email}}</a>
                    <h2>{{tr.for_media}}</h2>
                    <h3>{{tr.phone}}:</h3> <a href="tel:+7 (7172) 70-83-15">{{tr.pr_phone}}</a>
                    <h3>{{tr.email}}:</h3> <a href="mailto:pr@iwep.kz">{{tr.pr_email}}</a>
                </div>
                <div class="col-sm-6">
                    <br>
                    <i-map :height="530" :coords="[51.116435, 71.442705]" :zoom="15" />
                </div>
            </div>
            <br>
            <br>
        </div>
    </div>
</template>
<script>
export default {
    name: 'contacts',
    computed: {
        seo() { return { title: this.trRaw.contacts, description: this.trRaw.contacts_meta_description } }
    },
    data() {
        return {
            logo: require("../assets/img/logo_black.png")
        }
    }
}
</script>
<style lang="css" scoped>
</style>